// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__rZVi9","thumb":"Switch_thumb__0Prmz"};